export const ERROR_CODES = {
  FAIL_TO_GAME_TOKEN_ROAMING_FOR_UNEXPECTED_ERROR: 113930,
  FAIL_TO_GAME_TOKEN_ROAMING_FOR_GUID_CONFLICT: 113931,
  FAIL_TO_GAME_TOKEN_ROAMING_FOR_CANCELLING_REACTIVATION: 113932,
  FAIL_TO_GAME_TOKEN_ROAMING_FOR_CANCELLING_RECOVERY: 113933,
  FAIL_TO_GAME_TOKEN_ROAMING_FOR_CANCELLING_RELEASE_NSRRS_BY_IDENTITY_VERIFICATION: 113934,
}

export const ERROR_NAMES = {
  [ERROR_CODES.FAIL_TO_GAME_TOKEN_ROAMING_FOR_UNEXPECTED_ERROR]: 'FAIL_TO_GAME_TOKEN_ROAMING_FOR_UNEXPECTED_ERROR',
  [ERROR_CODES.FAIL_TO_GAME_TOKEN_ROAMING_FOR_GUID_CONFLICT]: 'FAIL_TO_GAME_TOKEN_ROAMING_FOR_GUID_CONFLICT',
  [ERROR_CODES.FAIL_TO_GAME_TOKEN_ROAMING_FOR_CANCELLING_REACTIVATION]: 'FAIL_TO_GAME_TOKEN_ROAMING_FOR_CANCELLING_REACTIVATION',
  [ERROR_CODES.FAIL_TO_GAME_TOKEN_ROAMING_FOR_CANCELLING_RECOVERY]: 'FAIL_TO_GAME_TOKEN_ROAMING_FOR_CANCELLING_RECOVERY',
  [ERROR_CODES.FAIL_TO_GAME_TOKEN_ROAMING_FOR_CANCELLING_RELEASE_NSRRS_BY_IDENTITY_VERIFICATION]:
    'FAIL_TO_GAME_TOKEN_ROAMING_FOR_CANCELLING_RELEASE_NSRRS_BY_IDENTITY_VERIFICATION',
}
